"use client";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Icons } from "@/components/Icons";

/**
 * Static default quick-issue list for M1 (mock's "Common issues" chip row).
 * Per-branch configurable chip sets are a later milestone — see task brief.
 */
export const DEFAULT_QUICK_ISSUES = [
  "order_late",
  "food_cold",
  "wrong_items",
  "bad_service",
  "other",
] as const;

export type QuickIssueId = (typeof DEFAULT_QUICK_ISSUES)[number];

type QuickIssueChipsProps = {
  selected: string[];
  onToggle: (id: string) => void;
};

/** Tap-to-append chip row of common negative-review issues. */
export function QuickIssueChips({ selected, onToggle }: QuickIssueChipsProps) {
  const { t } = useTranslation();

  return (
    <div>
      <div style={{ fontSize: 12.5, fontWeight: 600, color: "var(--ink-2)", marginBottom: 9 }}>
        {t("v2.reviews.quick_issues.heading", "Common issues — tap to add")}
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
        {DEFAULT_QUICK_ISSUES.map((id) => {
          const on = selected.includes(id);
          return (
            <button
              key={id}
              type="button"
              onClick={() => onToggle(id)}
              aria-pressed={on}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 5,
                height: 34,
                padding: "0 13px",
                borderRadius: "var(--radius-chip)",
                background: on ? "var(--primary-50)" : "var(--surface-2)",
                border: `1px solid ${on ? "var(--primary-600)" : "var(--border)"}`,
                color: on ? "var(--primary-700)" : "var(--ink-2)",
                fontSize: 12.5,
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              {on && <Icons.check size={13} sw={2.5} />}
              {t(`v2.reviews.quick_issues.${id}`)}
            </button>
          );
        })}
      </div>
    </div>
  );
}
